import React, { createContext, useContext } from "react";

// Feature entitlements default ON so UI never flickers hidden before the fetch resolves.
export const FeatureFlagContext = createContext({
  merit_tracking: true, lettering: true, theatre_brand: false, choices: true, phonebook: true, schedule: true,
  animations: false, parent_account: true, rally_books: true,
  district_admin_account: true, campus_admin_account: true,
  document_depot: true, document_upload: false, attendance: false, conflicts: false, volunteers: false, thespian: false, bios: false, show_notes: false,
});

export function useFeatureFlags() {
  return useContext(FeatureFlagContext);
}

export function FeatureDisabled({ name }) {
  return (
    <div className="mx-auto max-w-md py-20 text-center" data-testid="feature-disabled">
      <h2 className="font-heading text-lg font-semibold text-slate-800">{name} is turned off</h2>
      <p className="mt-2 text-sm text-slate-500">
        This feature is not enabled for your organization. Please contact your system administrator.
      </p>
    </div>
  );
}

// Route guard: shows the FeatureDisabled screen when the given entitlement is off for the org.
export function FeatureRoute({ flag, name, children }) {
  const flags = useFeatureFlags();
  if (flags[flag] === false) return <FeatureDisabled name={name} />;
  return children;
}

// Route guard: hides the route (FeatureDisabled) when the org's plan is in `hideOn`.
export function PlanRoute({ hideOn = [], name, children }) {
  const { plan } = useFeatureFlags();
  if (plan && hideOn.includes(plan)) return <FeatureDisabled name={name} />;
  return children;
}
